import * as React from 'react';
import { ListItem } from '@material-ui/core';
import { NavLink } from 'react-router-dom';

interface OwnProps {
  to: string;
  label: string;
}
const ListButtonLink: React.SFC<OwnProps> = (props: OwnProps) => {
  return (
    <div style={{ padding: '2px' }}>
      <NavLink
        style={{textDecoration: 'none', color: 'unset'}}
        to={props.to}
      >
        <ListItem
          button
          divider
          dense
          style={{
            fontSize: '14px',
            color: '#3f51b5',
            border: 'solid 1px rgba(63, 81, 181, 0.5)',
            borderRadius: '4px'
          }}
        >
          {props.label}
        </ListItem>
      </NavLink>
    </div>
  );
}

export default ListButtonLink;



// WEBPACK FOOTER //
// ./src/components/parts/ListButtonLink.tsx